// Google Analytics (gtag.js) with Google Consent Mode v2 (LSSI-CE art. 22 / GDPR).
//
// The measurement ID comes from VITE_GA_MEASUREMENT_ID (baked in at build time).
// When it is unset — dev, test, any environment without the var — this module
// does nothing, so those environments never load GA.
//
// gtag.js loads on every page, but the default consent state is "denied": until
// the visitor accepts, Google sends only cookieless pings (no analytics cookie,
// no identifiers), which lets it verify the tag and provide modelled/aggregate
// data. On "Accept" we update analytics_storage to "granted" and full,
// cookie-based collection begins without a reload. Ad signals stay "denied" —
// this is an analytics-only setup, no Google Ads.

export {}

const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

declare global {
  interface Window {
    dataLayer: unknown[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    gtag: (...args: any[]) => void
  }
}

function hasAccepted(): boolean {
  return document.cookie
    .split('; ')
    .some((c) => c === 'cookie_consent=accepted')
}

if (MEASUREMENT_ID) {
  window.dataLayer = window.dataLayer || []
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments)
  }

  // Consent defaults must be set before the tag processes any hits. A returning
  // visitor who already accepted starts "granted"; everyone else starts "denied".
  window.gtag('consent', 'default', {
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
    analytics_storage: hasAccepted() ? 'granted' : 'denied',
    wait_for_update: 500,
  })

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  document.head.appendChild(script)

  window.gtag('js', new Date())
  window.gtag('config', MEASUREMENT_ID)

  // Grant analytics consent the moment the visitor accepts, without a reload.
  document.addEventListener(
    'cookie-consent:accepted',
    () => window.gtag('consent', 'update', { analytics_storage: 'granted' }),
    { once: true },
  )
}
